<app-button-neutral class="left-button"
  (btnClick)="emit_btnClick_previousTab()"
  [loadKey]="loadKey.screenLock"
  [lockOnLoad]="true"
  [color]="'color4'"
  [style.visibility]="!isBeginList$$() ? '' : 'hidden'"
  [tooltip]="tabLabel_previous$$()"
  >
  <app-icon name="caret-left" /><span>previous tab</span>
</app-button-neutral>
@if (this.hasList$$()) {
  <app-tabs-dropdown
    (openedChangeEmit)="emit_openedChange($event)"
    (valueChangeEmit)="emit_ValueChange($event)"
    [classHeight]="'s-height'"
    [list]="tablistDropdown$$()"
    [value]="tabIndex$$()"
    />
}
<app-button-neutral class="right-button"
  (btnClick)="emit_btnClick_nexTab()"
  [color]="'color4'"
  [loadKey]="loadKey.screenLock"
  [lockOnLoad]="true"
  [style.visibility]="!isEndList$$() ? '' : 'hidden'"
  [tooltip]="tabLabel_next$$()"
  >
  <span>next tab</span><app-icon name="caret-right" />
</app-button-neutral>
